// Generated verbatim from docs/legal/12.1.1 Website Terms of Use - misekitchen.ca (amended 2026-10-22).docx
// and docs/legal/12.1.2 Website Privacy Policy - misekitchen.ca (amended 2026-10-22).docx.
// Do not edit by hand: change the .docx, then run docs/legal/generate_legal_js.py.
// Each run is [text, bold].
const LEGAL_DOCUMENTS = {
  "terms": [
    {
      "type": "title",
      "runs": [
        [
          "WEBSITE TERMS OF USE",
          true
        ]
      ]
    },
    {
      "type": "effective",
      "runs": [
        [
          "Effective October 22, 2026",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "1.",
      "runs": [
        [
          "Introduction",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "The following sets out the terms and conditions of use (the “",
          false
        ],
        [
          "Terms of Use",
          true
        ],
        [
          "”) for our website: ",
          false
        ],
        [
          "www.misekitchen.ca",
          true
        ],
        [
          " (the “",
          false
        ],
        [
          "Site",
          true
        ],
        [
          "”) made available by ",
          false
        ],
        [
          "Fin-Free C. Corp., carrying on business as Mise Kitchen (“Mise Kitchen”",
          true
        ],
        [
          ", “",
          false
        ],
        [
          "we",
          true
        ],
        [
          "”, “",
          false
        ],
        [
          "us",
          true
        ],
        [
          "” or “",
          false
        ],
        [
          "our",
          true
        ],
        [
          "”).",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "The purpose of the Site is to provide information about Mise Kitchen and our platforms, Mise at Home, Mise: Family Meals and Mise: Heart of House (each, a “",
          false
        ],
        [
          "Platform",
          true
        ],
        [
          "”), and to allow you to contact us.  The contents of the Site include, without limitation, information, data, products, materials, services, software applications and tools, design elements, text, images, photographs, illustrations, audio and video contents, artwork, graphics contained therein or otherwise made available to you in connection therewith (collectively the “",
          false
        ],
        [
          "Contents",
          true
        ],
        [
          "”) and, unless the context clearly requires otherwise, or we explicitly say so in writing, the term Site includes all of the Contents. These Terms of Use constitute a legally binding agreement between you and us regarding your use of and access to the Site. These Terms of Use do not alter in any way the terms and conditions of any other agreement you may have with us, unless otherwise agreed to in writing by us. Each Platform is made available under its own terms of use or subscription agreement and privacy notice, which govern your use of that Platform. Descriptions, features and pricing of the Platforms on the Site are provided for information only, do not constitute an offer and may change without notice.  If you breach any of these Terms of Use, your authorization to use the Site automatically terminates and you must immediately destroy any Contents in your possession and discontinue all use of the Site.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "2.",
      "runs": [
        [
          "Provision of the Site",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "You acknowledge and agree that the form and nature of the Site may change from time to time without prior notice to you.  You acknowledge and agree that we may stop (permanently or temporarily) providing the Site (or any features within the Site) to you or to users generally, at our sole discretion. However, we will endeavor to provide you with reasonable prior notice where possible.  You may stop using the Site at any time.  You do not need to inform us when you stop using the Site or any of its features.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "3.",
      "runs": [
        [
          "Use of the Site",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "Your use of the Site is subject to all applicable local, provincial, state and federal laws and regulations.  You may not use, allow, or enable others to use the Site, or knowingly condone use of the Site by others, in any manner that is, attempts to, or is likely to: (a) be obscene, fraudulent, defamatory, libelous, indecent, discourteous, racially or ethnically offensive, harassing, threatening, abusive, pornographic or discriminatory; (b) affect us adversely or reflect negatively on us, the Site, our goodwill, name or reputation or cause duress, distress, or discomfort to us or anyone else, or discourage any person, firm, or enterprise from using all or any portion, features, or functions of the Site, or from advertising, linking, or becoming a supplier to us in connection with the Site; (c) send or result in the transmission of junk e-mail, chain letters, duplicative or unsolicited messages, or so-called “spamming” and “phishing”; (d) transmit, distribute, or upload content or programs that contain any viruses, Trojan horses, worms or other disabling devices or harmful components intended to damage, detrimentally interfere with, surreptitiously intercept, or expropriate any system, data or personal information; (e) modify, disrupt, impair, alter, or interfere with the use, features, functions, operation, or maintenance of the Site or the rights or use and enjoyment of the Site by any other user; (f) advocate or encourage any illegal activity; (g) infringe upon or misappropriate the copyright, patent, trademark, trade secret, publicity rights or other intellectual property or proprietary rights of us or any third party; (h) violate the privacy of any individual, including users of the Site; or (i) violate any applicable local, provincial, state or national laws or regulations (anywhere in the world).",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "Unless you have been specifically permitted to do so in a separate written agreement with us, you agree that you will not reproduce, duplicate, copy, sell, trade or resell the Contents or any of our products and services for any purpose. You agree that you are solely responsible for (and that we have no responsibility to you or to any third party for) any breach of your obligations under these Terms of Use and for the consequences (including any loss or damage which we may suffer) of any such breach.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "4.",
      "runs": [
        [
          "Accepting the Terms of Use and Additional Terms",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "By accessing and using the Site in any manner, you acknowledge that you have read these Terms of Use and all of the terms and conditions contained herein.  Before continuing to use the Site, please read these Terms of Use and contact us if you have any questions.  We reserve the right to amend, modify and supplement these Terms of Use from time to time as we see fit with additional terms and conditions that govern certain information, content, products and services made available to you via the Site (“",
          false
        ],
        [
          "Additional Terms",
          true
        ],
        [
          "”).  By accessing and using the Site, you accept and agree to comply with and be bound by such Additional Terms.  Please review these Terms of Use from time to time to ensure that you are aware of and understand any Additional Terms.  The Additional Terms and our privacy policy (the “",
          false
        ],
        [
          "Privacy Policy",
          true
        ],
        [
          "”) (both available on the Site) are hereby incorporated by reference into these Terms of Use and form part of the legally binding agreement between you and us.  To the extent that there is a conflict between these Terms of Use and any Additional Terms, the Additional Terms shall govern.  These Terms of Use will remain in full force and effect as long as you are a user of the Site and, in the event of termination of any product, service or feature, you will still be bound by your obligations under these Terms of Use, the Privacy Policy and any Additional Terms.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "5.",
      "runs": [
        [
          "Links to Third-Party Sites",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "Clicking on certain links on the Site may redirect you to third-party websites.  Such third party websites are not under our control, and we are not responsible for the contents of any such website or any link contained in such website.  The third party links included on the Site, if any, are provided for your convenience, and the inclusion of such links does not imply a recommendation or endorsement by us of any such website or the products or services offered therein.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "6.",
      "runs": [
        [
          "Privacy and Personal Information",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "Our collection, use and disclosure of personal information through the Site is described in the Privacy Policy at https://misekitchen.ca/privacy. While we make every effort to ensure the integrity and security of our network and systems, we cannot guarantee that our security measures will prevent third-party “hackers” from illegally obtaining personal information. Questions or requests with respect to your personal information may be sent via email to support@misekitchen.ca.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "7.",
      "runs": [
        [
          "Ownership of Intellectual Property Rights",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "The Site together with all trade-marks and other intellectual property displayed, distributed, or otherwise made available via the Site, is the exclusive property of us, and our successors, assigns, licensors, and/or suppliers.  Unless you have agreed otherwise in writing with us, nothing in these Terms of Use gives you a right to use any of the Contents, our trade-marks or other intellectual property.  You may not assign or transfer any of the Contents and you may not grant a license to use or access the Site to any party. You may use the Site and the Contents solely for your own information, including to evaluate the Platforms, and for no other purposes. No information or statement contained in these Terms of Use or the Site shall be construed as conferring, directly or by implication, estoppel or otherwise, any license or right under any patent, copyright, trade-mark, or other intellectual property right of Mise Kitchen or any third party.  You must not alter, delete, or conceal any copyright or other notices contained on the Site, including notices on any of the Contents that you are permitted to download, transmit, display, print, or reproduce from the Site. You may not allow any third party (whether or not for your benefit) to reproduce, modify, create derivative works from, display, perform, publish, distribute, disseminate, broadcast or circulate to any third party (including, without limitation, on or via a third party website), or otherwise use, any Contents without the express prior written consent of us or its owner if",
          false
        ],
        [
          " ",
          true
        ],
        [
          "we are not the owner. Any unauthorized or prohibited use of any Contents may subject you to civil liability, criminal prosecution, or both, under applicable federal, provincial, state and local laws. You may create a link to the home page of the Site, provided that such link does not portray us or any of our activities or services in a false, misleading, derogatory, or otherwise negative manner. The limited rights granted to you under these Terms of Use may be revoked by us at any time for any reason whatsoever.  ",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "8.",
      "runs": [
        [
          "Intellectual Property Infringement",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "We take intellectual property rights, both our own and others, very seriously.  If you are an owner of intellectual property (or the owner's authorized agent) and believe that any of the Contents or the Site infringes your intellectual property, please notify us using the following procedure:",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "Please send a written notice of intellectual property infringement to: support@misekitchen.ca",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "In your written notice, please provide the following information: (a) identification of the intellectual property claimed to have been infringed; (b) identification of the Contents that you claim are infringing your intellectual property; (c) information sufficient to permit us to contact you, such as an address, telephone number, and, if available, an electronic mail address at which you may be contacted; (d) a statement that you believe that use of the Contents in the manner complained of is not authorized by the owner, its agent, or the law; and (e) a statement that the information in the notification is accurate and that you are the owner or are authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "9.",
      "runs": [
        [
          "Third-Party Information",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "Any third-party content, data or publications made available through the Site are furnished by us on an as-is basis for your convenience and information.  Any opinions, advice, statements, services, offers, or other information made available by third parties, including information providers, are those of the respective author(s) or publisher(s). We provide no warranties or representations, either express or implied, regarding the accuracy or completeness of third-party information on the Site.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "10.",
      "runs": [
        [
          "No Warranty",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR USE OF THE SITE IS AT YOUR SOLE RISK AND THAT THE SITE AND THE CONTENTS ARE PROVIDED “AS IS” AND “AS AVAILABLE.” IN PARTICULAR, WE AND OUR LICENSORS DO NOT REPRESENT OR WARRANT TO YOU THAT: (A) YOUR USE OF THE SITE WILL MEET YOUR REQUIREMENTS; (B) YOUR USE OF THE SITE WILL BE UNINTERRUPTED, TIMELY, SECURE OR FREE FROM ERROR; (C) ANY INFORMATION OBTAINED BY YOU AS A RESULT OF YOUR USE OF THE SITE WILL BE ACCURATE OR RELIABLE, AND (D) THAT DEFECTS IN THE OPERATION OR FUNCTIONALITY OF ANY SOFTWARE PROVIDED TO YOU AS PART OF THE SITE WILL BE CORRECTED. ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SITE IS DONE AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR OTHER DEVICE OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY SUCH MATERIAL. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM US OR THROUGH OR FROM THE SITE SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THESE TERMS OF USE. WE FURTHER EXPRESSLY DISCLAIM ALL WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "11.",
      "runs": [
        [
          "Limitation of Liability",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU EXPRESSLY UNDERSTAND AND AGREE THAT WE, AND OUR LICENSORS SHALL NOT BE LIABLE TO YOU FOR: (A) ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES WHICH MAY BE INCURRED BY YOU, HOWEVER CAUSED AND UNDER ANY THEORY OF LIABILITY INCLUDING, BUT NOT LIMITED TO, ANY LOSS OF PROFIT, LOSS OF GOODWILL OR BUSINESS REPUTATION, LOSS OF DATA SUFFERED, COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR OTHER INTANGIBLE LOSS; AND (B) ANY LOSS OR DAMAGE WHICH MAY BE INCURRED BY YOU, INCLUDING BUT NOT LIMITED TO LOSS OR DAMAGE AS A RESULT OF: (1) ANY CHANGES WHICH WE MAY MAKE TO THE SITE, OR FOR ANY PERMANENT OR TEMPORARY CESSATION IN THE PROVISION OF THE SITE (OR ANY FEATURES WITHIN THE SITE); (2) THE DELETION OF, CORRUPTION OF, OR FAILURE TO STORE, ANY COMMUNICATIONS DATA MAINTAINED OR TRANSMITTED BY OR THROUGH YOUR USE OF THE SITE. THE LIMITATIONS ON OUR LIABILITY TO YOU IN THIS SECTION SHALL APPLY WHETHER OR NOT WE HAVE BEEN ADVISED OF OR SHOULD HAVE BEEN AWARE OF THE POSSIBILITY OF ANY SUCH LOSSES ARISING. IF, DESPITE THE FOREGOING, WE ARE FOUND LIABLE TO YOU, OUR TOTAL LIABILITY ARISING OUT OF OR RELATING TO THE SITE OR THESE TERMS OF USE WILL NOT EXCEED ONE HUNDRED DOLLARS ($100).",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "12.",
      "runs": [
        [
          "Termination",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "We may terminate your use of the Site and/or access to the Contents, features, functionality, products and services made available in connection therewith, at any time and for any reason, with or without cause, without prior notice to you and without any liability or further obligation of any kind whatsoever to you or any other party.",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "We may at any time, terminate your use of the Site if: (a) you have breached any provision of these Terms of Use (or have acted in a manner which clearly shows that you do not intend to, or are unable to comply with the provisions of the Terms of Use); (b) we are required to do so by law (for example, where the provision of the Site to you is, or becomes, unlawful); (c) we are transitioning to no longer providing the Site to users in the country in which you are resident or from which you use the Site; or (d) the provision of the Site to you by us is, in our opinion, no longer commercially viable. When these Terms of Use come to an end, all of the legal rights, obligations and liabilities that you and we have benefited from, been subject to (or which have accrued over time while the Terms of Use have been in force) or which are expressed to continue indefinitely, shall be unaffected by such termination.",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "13.",
      "runs": [
        [
          "Indemnification",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "You agree to indemnify, defend, and hold us harmless and our successors and assigns, and any of ours and their respective officers, directors, employees, members, agents, representatives, licensors and suppliers from any liability, loss, claim, and expense (including reasonable legal fees) related to (a) your violation of these Terms of Use; and (b) your use of the Site. We reserve the right to assume, at our sole expense, the exclusive defense and control of any such claim or action and all negotiations for settlement, or compromise, and you agree to fully cooperate with us in the defense of any such claim, action, settlement or compromise negotiations, as we may request.  ",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "14.",
      "runs": [
        [
          "General",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "These Terms of Use, together with any Additional Terms and the Privacy Policy constitute the entire agreement between you and us relating to your use and our provision of the Site. You agree that we may provide you with notices, including those regarding changes to these Terms of Use, by email, regular mail, or postings on the Site. You agree that if we do not exercise or enforce any legal right or remedy which is contained in these Terms of Use (or which we have the benefit of under any applicable law), this will not be taken to be a formal waiver of our rights and that those rights or remedies will still be available to us. If any provision of these Terms of Use is held to be illegal, invalid or unenforceable, this will not affect any other provision of these Terms of Use and the agreement between you and us will be deemed amended to the extent necessary to make it legal, valid, and enforceable. The laws of the Province of Alberta and the federal laws applicable therein shall govern these Terms of Use in all respects, without giving effect to conflicts of laws principles, and you and we submit to the exclusive jurisdiction of the courts of the Province of Alberta. No e-mail address found on the Site may be harvested or otherwise used for purposes of solicitation. ",
          false
        ]
      ]
    },
    {
      "type": "heading",
      "number": "15.",
      "runs": [
        [
          "Obtaining Consent",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "To request our consent for any of the actions for which such consent is required under these Terms of Use, please send an e-mail to support@misekitchen.ca.  We reserve the right to refuse any such requests in our sole discretion.",
          false
        ]
      ]
    }
  ],
  "privacy": [
    {
      "type": "title",
      "runs": [
        [
          "MISE KITCHEN",
          false
        ]
      ]
    },
    {
      "type": "title",
      "runs": [
        [
          "Privacy Policy",
          false
        ]
      ]
    },
    {
      "type": "effective",
      "runs": [
        [
          "Effective October 22, 2026. This Privacy Policy may be modified to be kept up to date",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "This Privacy Policy describes how Fin-Free C. Corp., carrying on business as Mise Kitchen (“",
          false
        ],
        [
          "Mise Kitchen",
          true
        ],
        [
          "”, “",
          false
        ],
        [
          "we",
          true
        ],
        [
          "”, “",
          false
        ],
        [
          "us",
          true
        ],
        [
          "” or “",
          false
        ],
        [
          "our",
          true
        ],
        [
          "”), collects, uses and discloses personal information through our website at www.misekitchen.ca (the “",
          false
        ],
        [
          "Site",
          true
        ],
        [
          "”). It does not apply to personal information collected through our platforms, Mise at Home, Mise: Family Meals and Mise: Heart of House.",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "We collect personal information through the Site with your consent, when you contact us or join a waitlist.",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "We do not sell any personal information.",
          false
        ]
      ]
    },
    {
      "type": "subheading",
      "runs": [
        [
          "How we collect and use personal information",
          false
        ]
      ]
    },
    {
      "type": "numbered",
      "number": "1.",
      "runs": [
        [
          "We do not use cookies or advertising tools on the Site. We use our own analytics tool, which runs on our own servers, to understand how the Site is used. It records the pages you view, the website or campaign link that brought you to the Site, the buttons you click, how far you scroll and how long you stay on each page, and your browser, operating system, device type, screen size and language. It links these to a random session identifier that is kept in your browser only until you close the tab. It does not record your name, email address, IP address or anything you type into a form, and we do not share this information with anyone. The Site stores your language preference in your browser so that pages display in the language you chose. The Site displays fonts provided by Google Fonts. When a page loads, your browser connects to Google’s servers, which receive your IP address and may process it outside Canada under Google’s privacy policy. We do not receive information about you from Google.",
          false
        ]
      ]
    },
    {
      "type": "numbered",
      "number": "2.",
      "runs": [
        [
          "We collect the personal information you provide when you contact us through the Site’s contact form, join a waitlist or email us, including your name, email address, organisation, city, the platform you are interested in and your message. We use it only to respond to you, including to follow up on pilot or partnership inquiries and to send you a beta invitation you have requested. We do not use it to send you promotional emails.",
          false
        ]
      ]
    },
    {
      "type": "subheading",
      "runs": [
        [
          "Where and how long we keep personal information",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "We hold personal information collected through the Site on secure servers located in Canada and the United States, including servers of service providers that host the Site and our email on our behalf.",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "We only keep personal information as long as we need it to respond to you and for the purposes described in this Privacy Policy, unless we are required by law, for example, tax law, to keep it for longer. ",
          false
        ]
      ]
    },
    {
      "type": "subheading",
      "runs": [
        [
          "How we keep personal information secure ",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "The security of personal information is important to us.  Although we cannot guarantee 100% security, we use reasonable and appropriate security measures to protect personal information against unauthorized use, loss, access, modification, destruction or disclosure while it is in our custody or under our control. These measures include physical, organizational, and technological measures. Physical measures include secure work areas, and technological measures include encryption, firewalls, anti-virus, and system security monitoring.  Organizational measures include access controls to limit access to personal information to those employees, contractors and agents who have a business need to know.",
          false
        ]
      ]
    },
    {
      "type": "subheading",
      "runs": [
        [
          "How we disclose personal information",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "We do not disclose any information in our custody to third parties unless it is with consent or required by law, except to our service providers in Canada and the United States that host the Site and our email, which may use it only to provide those services to us.",
          false
        ]
      ]
    },
    {
      "type": "subheading",
      "runs": [
        [
          "How we give access to personal information",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "You may request access to or ask to edit or remove your personal information that we collect and maintain by contacting us at support@misekitchen.ca. We will respond within 30 days. If we cannot provide access, for example because it would disclose personal information of a third person, we will provide justification. ",
          false
        ]
      ]
    },
    {
      "type": "subheading",
      "runs": [
        [
          "Questions and contact information",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "For individual requests to access personal information or to express concerns about protection of personal information at Mise Kitchen, please contact our Privacy Officer at support@misekitchen.ca or by mail at Fin-Free C. Corp., Attention: Privacy Officer, Suite 700, 215 9 Avenue SW, Calgary, Alberta T2P 1K3.",
          false
        ]
      ]
    },
    {
      "type": "p",
      "runs": [
        [
          "If you are not satisfied with our response, you may contact the Office of the Information and Privacy Commissioner of Alberta or the Office of the Privacy Commissioner of Canada.",
          false
        ]
      ]
    }
  ]
};

export default LEGAL_DOCUMENTS;
